import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { styled, keyframes } from 'styled-components';
import SvgToTop from '../../../../play-core/icons/ToTop';
import { Colors } from '../../../../play-core/styles/Colors';
import { zIndex } from '../../../../play-core/styles/z-index';
import { useScrollYPosition } from '../../hooks/use-scroll-position';
import { PlayContainer } from '../PlayContainer/PlayContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const ScrollTop = () => {
  const {
    t
  } = useTranslation();
  const y = useScrollYPosition();
  const minYScrolling = 1920;
  return /*#__PURE__*/_jsx(Fragment, {
    children: y >= minYScrolling && /*#__PURE__*/_jsx(Layout, {
      children: /*#__PURE__*/_jsx(PlayContainer, {
        children: /*#__PURE__*/_jsx(Button, {
          onClick: () => window.scroll({
            top: 0,
            behavior: 'smooth'
          }),
          "aria-label": t('global.toTop'),
          children: /*#__PURE__*/_jsx(SvgToTop, {})
        })
      })
    })
  });
};
const opacityAnimation = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
const Layout = styled.div.withConfig({
  displayName: "ScrollTop__Layout",
  componentId: "sc-1i9303j-0"
})(["height:0;pointer-events:none;z-index:", ";position:sticky;bottom:64px;right:0;width:100%;transition:opacity 1s ease-in-out;animation:", " 200ms ease-in-out;animation-fill-mode:forwards;"], zIndex.floatingAction, opacityAnimation);
const Button = styled.button.withConfig({
  displayName: "ScrollTop__Button",
  componentId: "sc-1i9303j-1"
})(["pointer-events:all;margin-left:auto;float:right;font-size:48px;color:", ";"], Colors.GREY_1a1a1a);